import AddressModel from '$gbusiness/models/address';

export default interface WarehouseModel {
  id: number;
  name: string;
  short?: string;
  orderOos?: boolean;
  address?: AddressModel | undefined;
  itemCount?: number;
  settings?: any;
}

export const deriveRawToWarehouse = (raw) => {
  if (!raw) return undefined;
  return {
    id: raw.id,
    name: raw.name,
    short: raw.short || '',
    ...(raw.orderOos !== null && { orderOos: raw.orderOos }),
    ...(raw.address && { address: raw.address }),
    itemCount: raw.itemCount || 0,
  };
};

export const initialWarehouse = {
  id: 0,
  name: '',
  short: '',
  itemCount: 0,
};

export const getOosLabel = (orderOos) => {
  switch (orderOos) {
    case 1:
      return 'YES';
    case 0:
      return 'NO';
    default:
      return 'DEFAULT';
  }
};
